import React from 'react';
import Sidebar from './Sidebar';
import VersionNueva from './VersionNueva';
import { ALTO_BARRA } from './BarraEscritorio';

const MainLayout = ({ children, fullBleed = false, edgeToEdge = false }) => {
  return (
    <div style={ALTO_BARRA ? { paddingTop: ALTO_BARRA } : undefined} className="cubre-barra fixed inset-0 flex w-full overflow-hidden bg-sura-blue">
      {/* Tras un deploy: recarga cuando nadie la usa, o la ofrece */}
      <VersionNueva />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0 h-full relative">

        {/* Floating Card */}
        <div className={`flex-1 bg-[#F8FAFC] overflow-hidden flex flex-col relative isolate ${edgeToEdge ? '' : 'm-3 rounded-2xl shadow-2xl border border-white/10'}`}>
          {/* Page Content */}
          <main className={`flex-1 overflow-y-auto animate-fadeIn scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent ${edgeToEdge ? '' : 'p-4 md:p-8'}`}>
            {fullBleed || edgeToEdge ? children : (
              <div className="max-w-[1600px] mx-auto pb-6">
                {children}
              </div>
            )}
          </main>
        </div>

        {/* Footer (Empty to maintain margin balance) */}
        {!edgeToEdge && (
          <footer className="py-1.5 px-8 select-none">
            {/* Espacio equilibrado con el margen superior */}
          </footer>
        )}
      </div>
    </div>
  );
};

export default MainLayout;
